import {
  clearHighlightNodes,
  wrapHighlightsWithSpan,
} from "./faq-search-highlight";
import {
  closeAllAccordions,
  openAccordionById,
} from "./faq-search-accordion-handler";
import { updateSearchCollection } from "./faq-search-update-collection";
import { searchCollection } from "./faq-search-lookup";
import { scrollToId } from "../anchor";
import { hideError, showError } from "./faq-search-error-handler";
import { ResultIndicator } from "./faq-search-result-indicator";

/**
 * Handle highlighting and jumping to result for a search
 * @param searchTerm The term to search for
 * @param resultIndicator An instance of a {@link ResultIndicator}
 */
export const handleSearch = (
  searchTerm: string,
  resultIndicator: ResultIndicator
) => {
  if (!searchTerm) {
    return;
  }

  clearHighlightNodes();
  closeAllAccordions();
  hideError();

  // text nodes change every time text is highlighted, so we have to update it
  const collection = updateSearchCollection();

  const results = searchCollection(collection, searchTerm);

  resultIndicator.setResults(results.map((result) => result.element));

  if (results.length === 0) {
    showError();
    return;
  }

  results.forEach((result, i) => {
    // scroll to first result
    if (i === 0) {
      scrollToId(result.id);
    }

    openAccordionById(result.id);

    result.ranges.forEach((range) => {
      wrapHighlightsWithSpan(range);
    });
  });
};
